'use client'

import { DeviceContext } from "@/context/deviceContext"
import { useContext } from "react"
import { useLiveStreamContext } from "../_config"
import { SportsLiveListType } from "@/type/list"

export default function MultiSelect({listItem}: {listItem: SportsLiveListType}) {
    const { mobileMode } = useContext(DeviceContext)
    const { stream_1, stream_2, stream_3, stream_4, streamLen, setStreamLen, DelViewUrl, AddViewUrl } = useLiveStreamContext()


    function setStreamWindow(streamIndex: number){
        if(streamIndex == 2 && streamLen == 1){
            setStreamLen(2)
        }else if(streamIndex > 2){
            setStreamLen(4)
        }
        
        AddViewUrl(listItem, streamIndex)
    }
    return (
        <div className="multi-select">
            <span className={stream_1 == listItem ? "selected" : ""} onClick={e=> setStreamWindow(1)}>1</span>
            <span className={stream_2 == listItem ? "selected" : ""} onClick={e=> setStreamWindow(2)}>2</span>
            {
                !mobileMode
                    ? <>
                        <span className={stream_3 == listItem ? "selected" : ""} onClick={e=> setStreamWindow(3)}>3</span>
                        <span className={stream_4 == listItem ? "selected" : ""} onClick={e=> setStreamWindow(4)}>4</span>
                    </>
                    : <></>
            }
        </div>
    )
}